import { ConfigProvider, Table } from "antd"
import { colors } from "../../services/style"

export const SL_Table = ({type, ...tableProps})=> {

    const renderTokens = () => {
        switch (type) {
            default: 
            return {
                colorBgContainer: colors['sl-gray'][1000],
                colorText: 'white',
                lineWidth: 0,
                colorSplit: 'transparent',
            }
        }
    }

    const renderTableComponents = () => {
        switch (type) {
            default: 
            return {
                headerSplitColor: 'transparent',
                stickyScrollBarBg: 'tranparent',
            }
        }
    }
    return <ConfigProvider
    theme={{
        components: {
            Table: renderTableComponents(),
        },
        token: renderTokens(),
    }}
>
    <Table
        {...tableProps}
    />
</ConfigProvider>
}